"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _balloon = require("@alicd/next/lib/balloon");

var _balloon2 = _interopRequireDefault(_balloon);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentTooltip = function (_React$Component) {
    (0, _inherits3.default)(ContentTooltip, _React$Component);

    function ContentTooltip(props) {
        (0, _classCallCheck3.default)(this, ContentTooltip);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ContentTooltip.__proto__ || (0, _getPrototypeOf2.default)(ContentTooltip)).call(this, props));

        _this.state = {
            visible: false
        };

        _this.handleVisibleChange = _this.handleVisibleChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ContentTooltip, [{
        key: "handleVisibleChange",
        value: function handleVisibleChange(visible) {
            if (!this.state.visible && visible && this.props.wrappedOnly) {
                var dom = _reactDom2.default.findDOMNode(this);
                var thisWidth = dom.getBoundingClientRect().width;
                var parentWidth = dom.parentElement.getBoundingClientRect().width;
                if (parentWidth >= thisWidth) {
                    return;
                }
            }
            this.setState({ visible: visible });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                trigger = _props.trigger,
                value = _props.value;


            return _react2.default.createElement(_balloon2.default.Tooltip, {
                className: "cn-table-tooltip",
                trigger: trigger,
                align: "t",
                text: value,
                visible: this.state.visible,
                onVisibleChange: this.handleVisibleChange
            });
        }
    }]);
    return ContentTooltip;
}(_react2.default.Component);

exports.default = ContentTooltip;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/ContentTooltip.js
// module id = 699
// module chunks = 0